import { Button } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { useLeadsSheetStore } from "../../../../../../../../stores/LeadsStore";
import { useLanguage } from "../../../../../../../../stores/LanguageStore";
import { useProfileStore } from "../../../../../../../../stores/UserStore";

const AddNote = ({ isMobile }) => {
  const lang = useLanguage((s) => s.language);
  const profile = useProfileStore((s) => s.profile);
  const current = useLeadsSheetStore((s) => s.current);
  const setCurrent = useLeadsSheetStore((s) => s.setCurrent);
  const handleAdd = () => {
    let alreadyThere = document.getElementById("note-creator");

    if (alreadyThere) {
      alreadyThere.focus();
    } else {
      let newNote = {
        date: new Date().toISOString(),
        id: "note-creator",
        date_updated: null,
        note: true,
        history_type: "note",
        isCreate: true,
        created_by: {
          id: profile.id,
          first_name: profile.first_name,
          last_name: profile.last_name,
        },
      };
      setCurrent({
        ...current,
        history: [newNote, ...(current?.history || [])],
      });
    }
  };

  return (
    <Button
      leftSection={<IconPlus size={18} />}
      onClick={handleAdd}
      size={isMobile ? "xs" : "md"}
      mr={isMobile ? 0 : 8}
    >
      {lang.prm.details.notes.button_label}
    </Button>
  );
};

export default AddNote;
